import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';

export interface TaskAlerta {
  id: number;
  proyectoId: number;
  proyectoCodigo?: string | null;
  proyectoNombre?: string | null;
  titulo: string;
  cargoNombre?: string | null;
  areaNombre?: string | null;
  fechaLimite?: string | null;
  esCritica: boolean;
  consecuenciaIncumplimiento?: string | null;
}

export interface MisAlertasResponse {
  criticas: TaskAlerta[];
  vencidas: TaskAlerta[];
  proximas7Dias: TaskAlerta[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class AlertasService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiUrl;

  misAlertas(): Observable<MisAlertasResponse> {
    return this.http.get<MisAlertasResponse>(`${this.base}/tasks/mis-alertas`);
  }
}
